import { View } from 'backbone';
import listService from 'ListService';
import eventBus         from 'EventBus.js';
import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import template from 'common-views/select-form-or-report-modal.ejs';

import FormsTreeView  from 'common-views/FormsView.js'
import ReportsTreeView  from 'common-views/ReportsView.js'

class SelectFormOrReportModalView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.panelOne = '#dbPanelOne';
        this.panelTwo = '#dbPanelTwo';
        this.mode = opts.mode;
        this.checkForInstances= opts.checkForInstances!==undefined ? opts.checkForInstances : true;
        this.publishedInstances= opts.publishedInstances!==undefined ? opts.publishedInstances : false;

        // PF-1857 Adding extra condition for selecting a form with instances.
        this.selectableFormWithInstances= opts.selectableFormWithInstances!==undefined ? opts.selectableFormWithInstances : false;

        this.events = {
            'click a.select-field': 'showList'
        };

        if (this.mode === 'form') {
            this.model.set('sectionTitle', 'App', {silent:true});
            this.options.tabs = Immutable.Map(
                {
                    'db_forms':         { title: 'Edit Apps' ,
                        panel1Class: FormsTreeView,   panel1View: undefined }
                } );
        } else if (this.mode === 'report') {
            this.model.set('sectionTitle', 'Report', {silent:true});
            this.options.tabs = Immutable.Map(
                {
                    'db_forms':       { title: 'Edit Reports',
                        panel2Class: ReportsTreeView, panel1View:undefined }
                } );
        } else {
            this.model.set('sectionTitle', 'App or Report', {silent:true});
            this.options.tabs = Immutable.Map(
                {
                    'db_forms':         { title: 'Edit Apps and Reports' ,
                        panel1Class: FormsTreeView,   panel1View: undefined,
                        panel2Class: ReportsTreeView, panel2View: undefined }
                }
            );

        }

        this.options.tabs.map( ( v, k ) => {
            const klazz1 = v.panel1Class;
            if ( klazz1 ) {
                v.panel1View = new klazz1( { model: this.model, el: this.panelOne,
                        checkForInstances:this.checkForInstances, publishedInstances:this.publishedInstances,

                    // PF-1857 Adding extra condition for selecting a form with instances.
                        selectableFormWithInstances:this.selectableFormWithInstances} );
            }
            const klazz2 = v.panel2Class;
            if ( klazz2 ) {
                v.panel2View = new klazz2( { model: this.model, el: this.panelTwo,
                    checkForInstances:this.checkForInstances, publishedInstances:this.publishedInstances,

                    // PF-1857 Adding extra condition for selecting a form with instances.
                    selectableFormWithInstances:this.selectableFormWithInstances} );
            }
        });

        this.listenTo( eventBus, 'ReportSelected', this.selectingReport);
        this.listenTo( eventBus, 'FormSelected', this.selectingForm);
        return this;
    }

    selectingReport(id, name,GUID,linkId) {
        this.model.set('selected', {name: name, id: id,GUID:GUID,linkId:linkId});
        this.model.set('selectedReport', name);
        this.model.set('selectedReportId', id);
        this.model.set('selectedReportGUID', id);
        $('button.btn-select-field').button("enable");
        if (this.mode === 'form') {
            $('#dbPanelOne').show();
            $('#dbPanelTwo').hide();
        } else if (this.mode === 'report') {
            $('#dbPanelOne').hide();
            $('#dbPanelTwo').show();
        }
    }

    selectingForm(id, name, GUID, linkId) {
        this.model.set('selected', {name: name, id: id, GUID:GUID, linkId: linkId});
        this.model.set('selectedForm', name);
        this.model.set('selectedFormId', id);
        this.model.set('selectedFormGUID', id);
        $('button.btn-select-field').button("enable");
        if (this.mode === 'form') {
            $('#dbPanelOne').show();
            $('#dbPanelTwo').hide();
        } else if (this.mode === 'report') {
            $('#dbPanelOne').hide();
            $('#dbPanelTwo').show();
        }
    }

    showList(e) {
        e.preventDefault();
        var target = e.target.getAttribute('data-target');

        if(target){
            var controlListSelector = constants.SELECT_FIELD_CLASS + ' .control-list.' + target;
            var pageListSelector = constants.SELECT_FIELD_CLASS + ' .page-list.' + target;
            $(pageListSelector).toggleClass('open-list');
            $(controlListSelector).slideToggle();

        }
    }

    closeModal() {
        $(constants.SELECT_FIELD_CLASS).remove();
    }

    selectItem(item){
        const selectedItem = item.getAttribute('data-selected-item');
        item.class = 'selected';
        if(selectedItem){
            const selectedDOMID = '#field-select-' + selectedItem;
            this.model.set('selected', listService.getObject(selectedItem));
            $('a.field-select').removeClass('selected');
            $(selectedDOMID).addClass('selected');
            $('button.btn-select-field').button("enable");
        }
    }

    bindListEvent() {
        $(constants.SELECT_FIELD_LIST_TOGGLE).on('click', (e)=>{
            this.showList(e);
        });
        $(constants.SELECT_FIELD_ITEM).on('click', (e)=>{
            e.preventDefault();
            this.selectItem(e.target);
        });
    }

    unbindListEvent() {
        $(constants.SELECT_FIELD_LIST_TOGGLE).off();
        $(constants.SELECT_FIELD_ITEM).off();
    }


    //===========================================================================================
    // Sets active state for tab having id tid. Uses tabs Map.
    //===========================================================================================
    _setActiveTab( tid ) {
/*        const headingText = this.options.tabs.get( tid ).title + ' Dashboard';

        // Don't have BB call render() here.
        // The Bootstrap active mechanism interferes with BB render.
        // Modify DOM item outside BB with direct JQuery for this case only.
        this.model.set('detailHeading', headingText, { silent: true });
        $(constants.ID_SEL + 'detailHeading').text( this.model.get('detailHeading') );

        this.options.currentTab = tid;
*/
    }


    //===========================================================================================
    // This method depends upon the DOM being settled at time of invocation.
    //===========================================================================================
    _dispatchTab( evt ){
        const tid = evt.currentTarget.id;
        const clear = '<div></div>';
        this._setActiveTab( tid );

        // Initially reset and silence all panel subviews
        this.options.tabs.map( ( v, k ) => {
            $( this.panelOne ).html( clear );

            if ( v.panel1View  ) {
                v.panel1View.undelegateEvents();
                if (v.panel1View.remove ) {
                    v.panel1View.remove();
                }
            }

            $( this.panelTwo ).html( clear );

            if ( v.panel2View  ) {
                v.panel2View.undelegateEvents();
                if (v.panel2View.remove ) {
                    v.panel2View.remove();
                }
            }
        });

        // Wake up panel1 of this tab only
        const panel1View = this.options.tabs.get( tid ).panel1View;
        if (panel1View ) {
            panel1View.render();
        }

        const panel2View = this.options.tabs.get( tid ).panel2View;
        if (panel2View ) {
            panel2View.render();
        }
        return this;
    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);

            // Show modal popup window
            this.dialog = $( constants.SELECT_FIELD_CLASS ).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 'auto',
                minHeight: 240,
                width: 450,
                minWidht: 240,
                modal: true,
                resizable: true,
                buttons: [
                    {
                        text: 'OK',
                        'class':'btn-select-field',
                        'disabled': true,
                        click: () => {
                            this.closeModal();
                            resolve(this.model.get('selected'));
                        }
                    },
                    {
                        text: 'Cancel',
                        'class':'btn-addAssetCancel',
                        click: () => {
                            this.closeModal();
                            reject();
                        }
                    }
                ],
                close: () => {
                    this.unbindListEvent();
                    this.closeModal();
                },
                open: () =>{
                    this.bindListEvent();
                    $( constants.SELECT_FIELD_CLASS ).closest('div.ui-dialog').append('<img id="modalResizeHandler" src="'+require("common/buttons/resize_handler.png")+'"/>');
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});

            this.delegateEvents();
            this.$el.css( 'cursor', 'default' );
            // Making the initial load of the db_forms section by "mocking" the evt object as if the tab was just clicked
            // and use the same function.
            this._dispatchTab({currentTarget:{id:'db_forms'}});
            return this;
        });
    }

}

export default SelectFormOrReportModalView;
